import { render, staticRenderFns } from "./TotalGrowpropertiesModal.vue?vue&type=template&id=73f9a475"
import script from "./TotalGrowpropertiesModal.vue?vue&type=script&lang=js"
export * from "./TotalGrowpropertiesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports